import { render } from "./App.vue?vue&type=template&id=a6e0862e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a6e0862e&lang=css"

import exportComponent from "D:\\a\\wca-portal-de-compras\\wca-portal-de-compras\\wcacompras-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__